import React, { useCallback, useMemo, useState } from 'react';
import { PayableAmount } from './PayableAmount';
import { AGENCY_BUNDLE_ID } from '../../../utils/AgencyBundleProducts';

export function SplitPaymentToggleContent(props) {
	const { cartData, coupon, addToCart } = props;

	const updateCart = useCallback(
		e => {
			let product = {
				download_id: AGENCY_BUNDLE_ID,
				price_id: parseInt(e.target.value),
			};

			if (coupon?.is_valid) {
				product.discount = coupon.code;
			}

			addToCart(product, true, true);
		},
		[cartData, coupon]
	);

	const agencyLifetime = useMemo(() => {
		if (!cartData) {
			return null;
		}

		return {
			index: cartData?.contents?.findIndex(
				item => +item.id === AGENCY_BUNDLE_ID
			),
			product: cartData?.contents?.find(
				item => +item.id === AGENCY_BUNDLE_ID
			),
		};
	}, [cartData]);

	const isSplitItemSelected = useMemo(() => {
		if (!cartData) {
			return null;
		}

		return cartData?.details?.find(item => {
			return cartData?.splits?.find(splitItem => {
				return (
					+splitItem?.price_id ===
						+item?.item_number?.options?.price_id &&
					+item?.id === AGENCY_BUNDLE_ID
				);
			});
		});
	}, [cartData]);

	return (
		<>
			<div className=" wp-checkout-split-payment-add">
				<ul className="wp-checkout-split-payment-item-list">
					{cartData?.splits?.map(option => (
						<li
							className="wp-checkout-split-payment-item"
							key={`radio-${option.price_id}`}
						>
							<input
								type="radio"
								name="splitPayment-item"
								id={`radio-${option.price_id}`}
								className="wp-checkout-checkbox-input"
								value={+option.price_id}
								checked={
									+agencyLifetime?.product?.options
										?.price_id === +option.price_id
								}
								onChange={updateCart}
							/>
							<label
								className="wp-checkout-checkbox-label splitPayment-add-checkbox"
								htmlFor={`radio-${option.price_id}`}
							></label>
							<label
								htmlFor={`radio-${option.price_id}`}
								className="wp-checkout-font-base split-payment-label"
							>
								{option.times} Months
							</label>
						</li>
					))}
				</ul>

				{isSplitItemSelected && (
					<PayableAmount product={isSplitItemSelected} />
				)}
			</div>
		</>
	);
}
